var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDialerAndDataIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C76953D0-3862-48A2-BFC8-F4ACFFFDEACE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-SignIn/SignUp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3.0-Mojo-SignUp",
    transform: "translate(-846.000000, -551.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-active",
    transform: "translate(760.000000, 526.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "signUp-dataDialer-icon",
    transform: "translate(89.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6271268,12.1590435 C7.23259708,12.1590435 2.19970693,15.2665007 2.18074215,15.2783905 L0.200796868,16.5942583 C-1.38752688,17.6200659 -1.75887049,18.99571 -1.75000385,20.1099628 C-1.73988766,20.9917751 -1.26129647,22.2489714 -0.761459327,23.4639348 C-0.483511791,24.1554465 0.0254438377,24.6089648 0.587276766,24.8142958 C1.19063229,25.0348019 1.87916628,24.9859137 2.50553024,24.5778142 L6.60363269,21.9211398 C7.08552224,21.6085241 7.47690877,21.1692685 7.72074225,20.7150361 C8.00727064,20.1812683 8.12670563,19.6282159 7.90064197,18.867005 C7.86094114,18.7315455 7.83323818,18.6185922 7.8112459,18.3127382 C8.47324693,17.7684042 10.357682,16.5097762 13.6275241,16.508477 C17.0237161,16.5098262 18.924438,17.8671104 19.5141011,18.3720689 C19.4483487,18.5535253 19.390617,18.746001 19.2999406,19.0539832 C19.1588597,19.5280333 19.2208487,20.1306115 19.5350619,20.7159528 C19.7788438,21.170089 20.1702345,21.60919 20.6530073,21.9215899 L24.7523408,24.5790659 C25.3746543,24.98556 26.0628957,25.0349547 26.6664024,24.8148179 C27.1746179,24.6294399 27.6870378,24.2784192 28.1291265,23.1894639 C28.5010429,22.2877387 28.9939675,21.0069135 29.0042233,20.1134839 C29.0131252,18.998041 28.6416864,17.6196983 27.0528007,16.5938347 L24.981175,15.221483 C24.3978226,14.8770049 19.6083736,12.1590435 13.6271268,12.1590435 Z",
    id: "Fill-1",
    stroke: "#0964DE",
    transform: "translate(13.627127, 18.550602) rotate(-132.000000) translate(-13.627127, -18.550602) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.1875761,
    y1: 3.50336529,
    x2: 19.9892819,
    y2: 3.30789833,
    id: "Line-4",
    stroke: "#45B209",
    strokeLinecap: "round",
    transform: "translate(25.271544, 2.739863) rotate(-1.000000) translate(-25.271544, -2.739863) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.2713476,
    y1: 13.0605048,
    x2: 20.0730535,
    y2: 12.8650378,
    id: "Line-4",
    stroke: "#45B209",
    strokeLinecap: "round",
    transform: "translate(25.355315, 12.297002) rotate(-1.000000) translate(-25.355315, -12.297002) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.9993908,
    y1: 8.22768016,
    x2: 20.0006092,
    y2: 8.08806091,
    id: "Line-4",
    stroke: "#45B209",
    strokeLinecap: "round",
    transform: "translate(24.000000, 8.157871) rotate(-1.000000) translate(-24.000000, -8.157871) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialerAndDataIcon);
export default __webpack_public_path__ + "static/media/dialer-and-data-icon.5137a3749506b07970d697efd300862e.svg";
export { ForwardRef as ReactComponent };